<script setup lang="ts">
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import { useI18n } from 'vue-i18n';
  import type { RoutedCustomerViewComponentProps } from '@/types';
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader.ts';

  defineOptions({ name: 'ChangePasswordView' });

  defineProps<RoutedCustomerViewComponentProps>();

  const { t } = useI18n();
  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();

  const ChangePasswordFormController = getAsyncComponentWithLoader(() => import('@/components/customerProfilePage/ChangePassword/ChangePasswordFormController.vue'));

</script>

<template>
  <PageContent
    class="gap-6 md:gap-10"
    :title="t('pages.changePassword.title')"
  >
    <ChangePasswordFormController />
  </PageContent>
</template>
